(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-custom-cart]');
    if (!root) return;

    var itemsEl = root.querySelector('[data-cart-items]');
    var emptyEl = root.querySelector('[data-cart-empty]');
    var layoutEl = root.querySelector('[data-cart-layout]');
    var subtotalEl = root.querySelector('[data-cart-subtotal]');
    var countNoteEl = root.querySelector('[data-cart-count-note]');
    var checkoutBtn = root.querySelector('[data-cart-checkout]');

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'GBP'
      });
    }

    function updateHeaderBubble(count) {
      var bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      var bubbleWrap = document.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (bubble) bubble.textContent = count;
        if (bubbleWrap) bubbleWrap.style.display = '';
      } else if (bubbleWrap) {
        bubbleWrap.style.display = 'none';
      }
    }

    function renderRow(item, index) {
      var row = document.createElement('div');
      row.className = 'custom-cart__row';
      row.setAttribute('data-cart-row', index + 1);

      var variantHtml = '';
      if (item.variant_title) {
        variantHtml = '<div class="custom-cart__row-variant">' + item.variant_title + '</div>';
      }

      row.innerHTML =
        '<a href="' + item.url + '" class="custom-cart__row-media">' +
          (item.image ? '<img src="' + item.image + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '">' : '') +
        '</a>' +
        '<div class="custom-cart__row-info">' +
          '<a href="' + item.url + '" class="custom-cart__row-title">' + item.product_title + '</a>' +
          variantHtml +
          '<div class="custom-cart__row-qty">' +
            '<button type="button" data-qty-minus>\u2212</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-qty-plus>+</button>' +
          '</div>' +
        '</div>' +
        '<div class="custom-cart__row-end">' +
          '<div class="custom-cart__row-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<button type="button" class="custom-cart__row-remove" data-remove-row>Remove</button>' +
        '</div>';

      row.querySelector('[data-qty-minus]').addEventListener('click', function () {
        changeLine(index + 1, item.quantity - 1);
      });
      row.querySelector('[data-qty-plus]').addEventListener('click', function () {
        changeLine(index + 1, item.quantity + 1);
      });
      row.querySelector('[data-remove-row]').addEventListener('click', function () {
        changeLine(index + 1, 0);
      });

      return row;
    }

    function renderCart(cart) {
      if (!cart.items.length) {
        layoutEl.style.display = 'none';
        emptyEl.style.display = 'block';
        updateHeaderBubble(0);
        return;
      }

      layoutEl.style.display = '';
      emptyEl.style.display = 'none';

      itemsEl.innerHTML = '';
      cart.items.forEach(function (item, index) {
        itemsEl.appendChild(renderRow(item, index));
      });

      subtotalEl.textContent = formatMoney(cart.total_price);
      countNoteEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
      checkoutBtn.disabled = false;

      updateHeaderBubble(cart.item_count);
    }

    function changeLine(line, quantity) {
      var row = itemsEl.querySelector('[data-cart-row="' + line + '"]');
      if (row) row.classList.add('is-updating');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          renderCart(cart);
        })
        .catch(function () {
          if (row) row.classList.remove('is-updating');
        });
    }

    // Initial render from the live cart on load, so this stays correct
    // even if it was updated by a quick-add button on a different page.
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
      });
  });
})();
